import { useEffect } from 'react';

import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import Button from '../../../../components/buttons/Button';
import type { WizardChildProps } from '../../../../components/Wizard/types';
import { CONTACT_SUPPORT_URL } from '../../../../config/constants';
import { analytics } from '../../../../services/analytics';
import { useStores } from '../../../../stores/useStores';

import classes from './ForgotPasswordSuccessSection.module.scss';

export const ForgotPasswordSuccessSection = observer((props: WizardChildProps) => {
  const { t } = useTranslation();
  const { authStore } = useStores();

  const landingKey = authStore.getLandingKey();

  useEffect(() => {
    if (props.isCurrent) {
      void analytics.sendEvent('log_in', {
        step_name: 'password_reset_email_sent',
        event_action: 'impression',
        triggered_by: 'reset_password',
        landingKey,
      });
    }
  }, [props.isCurrent, landingKey]);

  const handleBackToLogin = () => {
    if (props.forceStep) {
      props.forceStep(0, 'login');
    }
  };

  return (
    <div className={classes.successSection}>
      <div className={classes.headerSection}>
        <h2 className={classes.title}>{t('auth.resetPassword')}</h2>
        <p className={classes.subtitle}>{t('auth.passwordResetEmailSent')}</p>
        <p className={classes.description}>{t('auth.checkSpamOrContactSupport')}</p>
      </div>

      <div className={classes.actionSection}>
        <Button
          btnType="main"
          className={classes.supportButton}
          onClick={() => window.open(CONTACT_SUPPORT_URL, '_blank', 'noopener,noreferrer')}
        >
          {t('common.contactSupportUpperCase')}
        </Button>

        <div className={classes.backToLoginLink}>
          <span>{t('landing.direct.forgotPasswordSuccess.rememberPasswordPrefix')} </span>
          <span className={classes.backToLoginText} onClick={handleBackToLogin}>
            {t('landing.direct.forgotPasswordSuccess.backToLoginLink')}
          </span>
        </div>
      </div>
    </div>
  );
});
